(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-ai"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.h2a');
  if (!root) return;
  var tx = 50, ty = 35, cx = 50, cy = 35, raf = null;
  var fine = window.matchMedia('(pointer: fine)').matches;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function frame() {
    cx += (tx - cx) * 0.08;
    cy += (ty - cy) * 0.08;
    root.style.setProperty('--mx', cx.toFixed(2) + '%');
    root.style.setProperty('--my', cy.toFixed(2) + '%');
    if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) { raf = requestAnimationFrame(frame); }
    else { raf = null; }
  }
  function kick() { if (!raf) raf = requestAnimationFrame(frame); }

  if (fine && !still) {
    root.addEventListener('pointermove', function (e) {
      var r = root.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width) * 100;
      ty = ((e.clientY - r.top) / r.height) * 100;
      kick();
    });
  } else if (!still) {
    var t = 0;
    setInterval(function () {
      t += 0.02;
      tx = 50 + Math.cos(t) * 18;
      ty = 38 + Math.sin(t * 0.7) * 12;
      kick();
    }, 60);
  }

  // copertina che si inclina seguendo il cursore
  var book = root.querySelector('.h2a__book');
  if (book && fine && !still) {
    var card = book.querySelector('.h2a__bk');
    var trx = 0, tryy = 0, tl = 0, crx = 0, cry = 0, cl = 0, braf = null;
    var MAX = 11;
    function bframe() {
      crx += (trx - crx) * 0.12; cry += (tryy - cry) * 0.12; cl += (tl - cl) * 0.12;
      book.style.setProperty('--rx', crx.toFixed(2) + 'deg');
      book.style.setProperty('--ry', cry.toFixed(2) + 'deg');
      book.style.setProperty('--lift', cl.toFixed(3));
      if (Math.abs(trx - crx) > 0.02 || Math.abs(tryy - cry) > 0.02 || Math.abs(tl - cl) > 0.002) {
        braf = requestAnimationFrame(bframe);
      } else { braf = null; }
    }
    function bkick() { if (!braf) braf = requestAnimationFrame(bframe); }
    book.addEventListener('pointermove', function (e) {
      var r = book.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      tryy = (px - 0.5) * 2 * MAX;
      trx = (0.5 - py) * 2 * MAX;
      tl = 1;
      card.style.setProperty('--sx', (px * 100).toFixed(1) + '%');
      card.style.setProperty('--sy', (py * 100).toFixed(1) + '%');
      bkick();
    });
    book.addEventListener('pointerleave', function () { trx = 0; tryy = 0; tl = 0; bkick(); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
